export const manageReplicasRequestUrl = `${process.env.REACT_APP_URL_API_LARAVEL}/document_expedients/change_status_second_instance`;
